import React, { useMemo } from 'react';

import type { ICalendarPosition } from '@/types/schedule';
import type { IWeek, IWeekDay } from '@/types/calendar';

import { CalendarDisplayRange } from '@/store/enums';
import { DlsBlockDayView, DlsBlockMultidayView } from '@/components/common';
import { getCalendarPosition } from '@/helpers';
import { useTimezone } from '@/hooks';

interface IProps {
  day: IWeekDay;
  week: IWeek;
  selectedDays: CalendarDisplayRange;
  onMouseMove?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>, offset: number) => void;
  onMouseLeave?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export interface IDlsBlockViewProps {
  week: IWeek;
  dlsPosition: ICalendarPosition | null;
}

const DlsBlock = ({ day, week, selectedDays, onMouseMove, onMouseLeave }: IProps): React.ReactElement => {
  const { timezoneName } = useTimezone();
  const dlsPosition = useMemo<ICalendarPosition | null>(() => {
    if (week.dst) {
      return getCalendarPosition(week.dst.startBlock, week.dst.endBlock, timezoneName, day);
    }
    return null;
  }, [day, timezoneName, week.dst]);

  if (!day.isDlsDay) return <></>;

  if (selectedDays === CalendarDisplayRange.ONE_DAY)
    return (
      <DlsBlockDayView onMouseLeave={onMouseLeave} onMouseMove={onMouseMove} week={week} dlsPosition={dlsPosition} />
    );

  return <DlsBlockMultidayView day={day} week={week} dlsPosition={dlsPosition} />;
};

export { DlsBlock };
